<template>
    <div class="card-deal-params-block">
        <el-row v-if="canViewField( 'budget', statusId) && isValueVisible(budget, 'budget')">
            <el-col :span="10">
                <span class="gray">
                    Бюджет, руб.
                </span>
            </el-col>
            <el-col :span="14">
                <template v-if="editMode && canEditField( 'budget', statusId)">
                    <auto-numeric
                        v-model="budget"
                        :options="numericOptions"
                        class="autonumeric"
                    />
                    <div class="field-error" v-if="errors.budget" v-text="errors.budget[0]"></div>
                </template>
                <template v-else>
                    {{ budget | formatFinance }}
                </template>
            </el-col>
        </el-row>
        <el-row v-if="canViewField( 'contract_number') && isValueVisible(contract_number, 'contract_number')">
            <el-col :span="10">
                <span class="gray">
                    Договор №
                </span>
            </el-col>
            <el-col :span="14">
                <template v-if="editMode && canEditField( 'contract_number')">
                    <el-input size="mini" autocomplete="off" type="text" v-model="contract_number" />
                    <div class="field-error" v-if="errors.contract_number" v-text="errors.contract_number[0]"></div>
                </template>
                <template v-else>
                    {{ contract_number }}
                </template>
            </el-col>
        </el-row>
        <el-row v-if="canViewField( 'contract_date') && isValueVisible(contract_date, 'contract_date')">
            <el-col :span="10">
                <span class="gray">
                    Дата заключения
                </span>
            </el-col>
            <el-col :span="14">
                <template v-if="editMode && canEditField( 'contract_date')">
                    <el-date-picker
                        v-model="contract_date"
                        type="date"
                        placeholder="дд.мм.гггг"
                        clearable
                        format="dd.MM.yyyy"
                        value-format="dd.MM.yyyy"
                        :picker-options="pickerOptions"
                        size="mini"
                        class="w100"
                    />
                    <div class="field-error" v-if="errors.contract_date" v-text="errors.contract_date[0]"></div>
                </template>
                <template v-else>
                    {{ contract_date }}
                </template>
            </el-col>
        </el-row>
        <el-row v-if="canViewField( 'conclusion_id') && isValueVisible(conclusion_id, 'conclusion_id')">
            <el-col :span="10">
                <span class="gray">
                    Заключение
                </span>
            </el-col>
            <el-col :span="14">
                <template v-if="editMode && canEditField( 'conclusion_id')">
                    <el-select
                        v-model="conclusion_id"
                        placement="bottom"
                        popper-class="popper-dropdown"
                        clearable
                        placeholder="Заключение"
                        size="mini"
                    >
                        <el-option v-for="item in conclusionTypes" :key="item.id" :label="item.name" :value="item.id" />
                    </el-select>
                    <div class="field-error" v-if="errors.conclusion_id" v-text="errors.conclusion_id[0]"></div>
                </template>
                <template v-else>
                    {{ conclusionName }}
                </template>
            </el-col>
        </el-row>
        <el-row v-if="canViewField( 'start_production_date') && isValueVisible(start_production_date, 'start_production_date')">
            <el-col :span="10">
                <span class="gray">
                    Дата запуска в производство
                </span>
            </el-col>
            <el-col :span="14">
                <template v-if="editMode && canEditField( 'start_production_date')">
                    <el-date-picker
                        v-model="start_production_date"
                        type="date"
                        placeholder="дд.мм.гггг"
                        clearable
                        format="dd.MM.yyyy"
                        value-format="dd.MM.yyyy"
                        :picker-options="pickerOptions"
                        size="mini"
                        class="w100"
                    />
                    <div class="field-error" v-if="errors.start_production_date" v-text="errors.start_production_date[0]"></div>
                </template>
                <template v-else>
                    {{ start_production_date }}
                </template>
            </el-col>
        </el-row>
        <el-row v-if="canViewField( 'discount') && isValueVisible(discount, 'discount')">
            <el-col :span="10">
                <span class="gray">
                    Скидка, %
                </span>
            </el-col>
            <el-col :span="14">
                <template v-if="editMode && canEditField( 'discount')">
                    <auto-numeric
                        v-model="discount"
                        :options="numericOptions"
                        class="autonumeric"
                    />
                    <div class="field-error" v-if="errors.discount" v-text="errors.discount[0]"></div>
                </template>
                <template v-else>
                    {{ discount | formatFinance }}
                </template>
            </el-col>
        </el-row>
        <el-row v-if="canViewField( 'budget', statusId) && isValueVisible(prepay, 'prepay')">
            <el-col :span="10">
                <span class="gray">
                    Предоплата план, руб.
                </span>
            </el-col>
            <el-col :span="14">
                <template v-if="editMode && canEditField( 'budget', statusId)">
                    <auto-numeric
                        v-model="prepay"
                        :options="numericOptions"
                        class="autonumeric"
                    />
                    <div class="field-error" v-if="errors.prepay" v-text="errors.prepay[0]"></div>
                </template>
                <template v-else>
                    {{ prepay | formatFinance }}
                </template>
            </el-col>
        </el-row>
        <el-row v-if="canViewField( 'prepay', statusId) && isValueVisible(prepay, 'prepay')">
            <el-col :span="10">
                <span class="gray">
                    Предоплата факт, руб.
                </span>
            </el-col>
            <el-col :span="14">
                {{ prepay_actual | formatFinance }}
                <div class="field-error" v-if="errors.prepay_actual" v-text="errors.prepay_actual[0]"></div>
            </el-col>
        </el-row>
        <el-row v-if="canViewField( 'pay_type_id') && isValueVisible(pay_type_id, 'pay_type_id')">
            <el-col :span="10">
                <span class="gray">
                    Вид оплаты
                </span>
            </el-col>
            <el-col :span="14">
                <template v-if="editMode && canEditField( 'pay_type_id')">
                    <el-select
                        v-model="pay_type_id"
                        placement="bottom"
                        popper-class="popper-dropdown"
                        autocomplete
                        clearable
                        placeholder="Вид оплаты"
                        size="mini"
                    >
                        <el-option v-for="item in payTypesList" :key="item.id" :label="item.name" :value="item.id" />
                    </el-select>
                    <div class="field-error" v-if="errors.pay_type_id" v-text="errors.pay_type_id[0]"></div>
                </template>
                <template v-else>
                    {{ payTypeName }}
                </template>
            </el-col>
        </el-row>
        <el-row v-if="canViewField( 'delivery_payment_plan', statusId) && isValueVisible(delivery_payment_plan, 'delivery_payment_plan')">
            <el-col :span="10">
                <span class="gray">
                    Оплата при доставке план, руб.
                </span>
            </el-col>
            <el-col :span="14">
                <template v-if="editMode && canEditField( 'delivery_payment_plan', statusId)">
                    <auto-numeric
                        v-model="delivery_payment_plan"
                        :options="[numericOptions, getNumericOptionsForDeliveryPaymentPlan]"
                        class="autonumeric"
                    />
                    <div class="field-error" v-if="errors.delivery_payment_plan" v-text="errors.delivery_payment_plan[0]"></div>
                </template>
                <template v-else>
                    {{ delivery_payment_plan }}
                </template>
            </el-col>
        </el-row>
        <el-row v-if="canViewField( 'delivery_balance', statusId) && isValueVisible(delivery_balance, 'delivery_balance')">
            <el-col :span="10">
                <span class="gray">
                    Остаток по доставке, руб
                </span>
            </el-col>
            <el-col :span="14">
                {{ delivery_balance ? formatFinance(delivery_balance) : 0 }}
            </el-col>
        </el-row>
        <el-row v-if="canViewField( 'installer_balance', statusId) && isValueVisible(installer_balance, 'installer_balance')">
            <el-col :span="10">
                <span class="gray">
                    Остаток по монтажу, руб
                </span>
            </el-col>
            <el-col :span="14">
                {{ installer_balance ? formatFinance(installer_balance) : 0 }}
            </el-col>
        </el-row>
        <el-row v-if="canViewField( 'measurer_bonus') && isValueVisible(measurer_bonus, 'measurer_bonus')">
            <el-col :span="10">
                <span class="gray">
                    Бонус замерщика ½, руб
                </span>
            </el-col>
            <el-col :span="14">
                <template v-if="editMode && canEditField( 'measurer_bonus')">
                    <auto-numeric
                        v-model="measurer_bonus"
                        :options="numericOptions"
                        class="autonumeric"
                    />
                    <div class="field-error" v-if="errors.measurer_bonus" v-text="errors.measurer_bonus[0]"></div>
                </template>
                <template v-else>
                    {{ measurer_bonus | formatFinance }}
                </template>
            </el-col>
        </el-row>
        <el-row v-if="canViewField( 'promising_customer') && isValueVisible(promising_customer, 'promising_customer')">
            <el-col :span="10">
                <span class="gray">
                    Перспективный заказчик
                </span>
            </el-col>
            <el-col :span="1" v-if="editMode && canEditField( 'promising_customer')">
                <el-checkbox v-model="promising_customer" />
            </el-col>
            <el-col :span="1" v-else>
                <font-awesome-icon icon="check-square" class="orange" v-if="promising_customer" />
                <font-awesome-icon :icon="['far', 'square']" class="orange" v-else />
            </el-col>
        </el-row>
        <el-row v-if="canViewField( 'promising_customer_comment') && isValueVisible(promising_customer, 'promising_customer') && promising_customer">
            <el-col :span="14" :offset="10">
                <template v-if="editMode && canEditField( 'promising_customer_comment')">
                    <el-input
                        type="textarea"
                        :rows="2"
                        placeholder=""
                        v-model="promising_customer_comment"
                    />
                </template>
                <template v-else>
                    <div v-format-text="promising_customer_comment"></div>
                </template>
            </el-col>
        </el-row>
        <el-row v-if="canViewField( 'measure_photo') && isValueVisible(measure_photo, 'measure_photo')">
            <el-col :span="editMode ? 8: 10">
                <span class="gray">
                    Лист замера
                </span>
            </el-col>
            <el-col :span="2" v-if="editMode && canEditField( 'measure_photo')">
                <el-upload
                    action=""
                    :auto-upload="false"
                    :on-change="handleChange"
                    :on-exceed="handleExceed"
                    :limit="10"
                    :file-list="uploadFileList"
                    :show-file-list="false"
                    multiple
                    accept="image/*"
                >
                    <font-awesome-icon slot="trigger" icon="paperclip" class="orange pointer" />
                </el-upload>
            </el-col>
            <el-col :span="14">
                <template v-if="editMode && canEditField( 'measure_photo')">
                    <el-tag
                        v-for="file in uploadFileList"
                        :key="file.name"
                        :title="file.name"
                        closable
                        :type="''"
                        @close="handleClose(file)"
                        @click.native="handleTagClick(file)"
                        class="pointer"
                        size="mini"
                        :disable-transitions="true"
                    >
                        {{ cutString(file.name) }}
                    </el-tag>
                    <div class="field-error" v-if="errors.measure_photo" v-text="errors.measure_photo[0]"></div>
                </template>
                <template v-else>
                    <el-tag
                        v-for="file in measure_photo"
                        :key="file.id"
                        :title="file.name"
                        :type="''"
                        size="mini"
                        class="pointer"
                        @click.native="handleTagClick(file)"
                        :disable-transitions="true"
                    >
                        {{ cutString(file.name) }}
                    </el-tag>
                </template>
            </el-col>
        </el-row>
        <el-row v-if="true">
            <el-col :span="editMode ? 8: 10">
                <span class="gray">
                    Фото обьекта
                </span>
            </el-col>
            <el-col :span="2" v-if="true">
                <el-upload
                    action=""
                    :auto-upload="false"
                    :on-change="handleObjectPhotoChange"
                    :on-exceed="handleExceed"
                    :limit="10"
                    :file-list="uploadObjectPhotoFileList"
                    :show-file-list="false"
                    multiple
                    accept="image/*"
                >
                    <font-awesome-icon slot="trigger" icon="paperclip" class="orange pointer" />
                </el-upload>
            </el-col>
            <el-col :span="14">
                <template v-if="editMode && canEditField( 'object_photo')">
                    <el-tag
                        v-for="file in uploadObjectPhotoFileList"
                        :key="file.name"
                        :title="file.name"
                        closable
                        :type="''"
                        @close="handleObjectPhotoClose(file)"
                        @click.native="handleObjectPhotoTagClick(file)"
                        class="pointer"
                        size="mini"
                        :disable-transitions="true"
                    >
                        {{ cutString(file.name) }}
                    </el-tag>
                    <div class="field-error" v-if="errors.object_photo" v-text="errors.object_photo[0]"></div>
                </template>
                <template v-else>
                    <el-tag
                        v-for="file in object_photo"
                        :key="file.id"
                        :title="file.name"
                        :type="''"
                        size="mini"
                        class="pointer"
                        @click.native="handleObjectPhotoTagClick(file)"
                        :disable-transitions="true"
                    >
                        {{ cutString(file.name) }}
                    </el-tag>
                </template>
            </el-col>
        </el-row>
        <el-row v-if="canViewField( 'to_production') && isValueVisible(to_production, 'to_production')">
            <el-col :span="10">
                <span class="gray">
                    В производство
                </span>
            </el-col>
            <el-col :span="1" v-if="editMode && canEditField( 'to_production')">
                <el-checkbox v-model="to_production" />
            </el-col>
            <el-col :span="1" v-else>
                <font-awesome-icon icon="check-square" class="orange" v-if="to_production" />
                <font-awesome-icon :icon="['far', 'square']" class="orange" v-else />
            </el-col>
        </el-row>
        <el-row v-if="canViewField( 'contract_comment') && isValueVisible(contract_comment, 'contract_comment')">
            <el-col :span="10">
                <span class="gray">
                    Комментарий
                </span>
            </el-col>
            <el-col :span="14">
                <template v-if="editMode && canEditField( 'contract_comment')">
                    <el-input
                        type="textarea"
                        :rows="2"
                        placeholder=""
                        v-model="contract_comment"
                    />
                </template>
                <template v-else>
                    <div v-format-text="contract_comment"></div>
                </template>
            </el-col>
        </el-row>
        <el-row v-if="canViewField('delivery_date') && isValueVisible(delivery_date, null, false)">
            <el-col :span="10">
                <span class="gray">
                    Дата доставки
                </span>
            </el-col>
            <el-col :span="14">
                {{ delivery_date }}
            </el-col>
        </el-row>
        <el-row v-if="canViewField('installation_date') && isValueVisible(installation_date, null, false)">
            <el-col :span="10">
                <span class="gray">
                    Дата монтажа
                </span>
            </el-col>
            <el-col :span="14">
                {{ installation_date }}
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { cardMixin } from '@/mixins/card';
import FileSaver from 'file-saver';
import { pickerOptions } from '@/common/pickerOptions';
import { formatFinance } from '@/common/utilities';

export default {
    name: 'Contract',
    mixins: [
        cardMixin
    ],
    data() {
        return {
            uploadFileList: [],
            uploadObjectPhotoFileList: [],
            pickerOptions
        };
    },
    computed: {
        payTypeName() {
            return this.$store.state.deals.current.pay_type ? this.$store.state.deals.current.pay_type.name : '';
        },
        conclusionName() {
            return this.$store.state.deals.current.conclusion ? this.$store.state.deals.current.conclusion.name : '';
        },
        conclusionTypes() {
            return this.$store.state.references.conclusions;
        },
        payTypesList() {
            return this.$store.state.references.payTypes;
        },
        delivery_payment_plan: {
            get() {
                return this.$store.state.deals.current.delivery_payment_plan;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'delivery_payment_plan', value });
            }
        },
        delivery_balance: {
            get() {
                return this.$store.state.deals.current.delivery_balance;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'delivery_balance', value });
            }
        },
        contract_number: {
            get() {
                return this.$store.state.deals.current.contract_number;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'contract_number', value });
            }
        },
        contract_date: {
            get() {
                return this.$store.state.deals.current.contract_date;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'contract_date', value });
            }
        },
        conclusion_id: {
            get() {
                return this.$store.state.deals.current.conclusion_id;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'conclusion_id', value });
            }
        },
        start_production_date: {
            get() {
                return this.$store.state.deals.current.start_production_date;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'start_production_date', value });
            }
        },
        discount: {
            get() {
                return this.$store.state.deals.current.discount;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'discount', value });
            }
        },
        prepay: {
            get() {
                return this.$store.state.deals.current.prepay;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'prepay', value });
            }
        },
        prepay_actual: {
            get() {
                return this.$store.state.deals.current.prepay_actual;
            },
            set(value) {
                //this.$store.commit('deals/setCurrentField', { field: 'prepay', value });
            }
        },
        pay_type_id: {
            get() {
                return this.$store.state.deals.current.pay_type_id;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'pay_type_id', value });
            }
        },
        installer_balance: {
            get() {
                return this.$store.state.deals.current.installer_balance;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'installer_balance', value });
            }
        },
        budget: {
            get() {
                return this.$store.state.deals.current.budget;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'budget', value });
            }
        },
        measure_photo: {
            get() {
                return this.$store.state.deals.current.measure_photo;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'measure_photo', value });
            }
        },
        object_photo: {
            get() {
                return this.$store.state.deals.current.object_photo;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'object_photo', value });
            }
        },
        to_production: {
            get() {
                return this.$store.state.deals.current.to_production;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'to_production', value });
            }
        },
        measurer_bonus: {
            get() {
                return this.$store.state.deals.current.measurer_bonus;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'measurer_bonus', value });
            }
        },
        promising_customer: {
            get() {
                return this.$store.state.deals.current.promising_customer;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'promising_customer', value });
            }
        },
        promising_customer_comment: {
            get() {
                return this.$store.state.deals.current.promising_customer_comment;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'promising_customer_comment', value });
            }
        },
        contract_comment: {
            get() {
                return this.$store.state.deals.current.contract_comment;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'contract_comment', value });
            }
        },
        installation_date: {
            get() {
                return this.$store.state.deals.current.installation_date;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'installation_date', value });
            }
        },
        delivery_date: {
            get() {
                return this.$store.state.deals.current.delivery_date;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'delivery_date', value });
            }
        },
        getNumericOptionsForDeliveryPaymentPlan() {
            return {
                minimumValue: '0'
            };
        }
    },
    methods: {
        formatFinance,
        handleChange(file, fileList) {
            this.uploadFileList = fileList;
            this.$store.commit('deals/setCurrentField', { field: 'measure_photo', value: [...this.uploadFileList] });
        },
        handleObjectPhotoChange(file, fileList) {
            this.uploadObjectPhotoFileList = fileList;
            this.$store.commit('deals/setCurrentField', { field: 'object_photo', value: [...this.uploadObjectPhotoFileList] });
        },
        handleExceed() {
            this.$message({
                showClose: true,
                message: 'Внимание, лимит 10 файлов!',
                type: 'warning',
                duration: 5000,
                customClass: this.alertClass()
            });
        },
        handleClose(tag) {
            this.uploadFileList.splice(this.uploadFileList.indexOf(tag), 1);
            this.$store.commit('deals/setCurrentField', { field: 'measure_photo', value: [...this.uploadFileList] });
        },
        handleObjectPhotoClose(tag) {
            this.uploadObjectPhotoFileList.splice(this.uploadObjectPhotoFileList.indexOf(tag), 1);
            this.$store.commit('deals/setCurrentField', { field: 'object_photo', value: [...this.uploadObjectPhotoFileList] });
        },
        handleTagClick(tag) {
            if (!tag.id) {
                return;
            }
            this.$store.dispatch('deals/getPhoto', { block: 'measure', id: tag.id })
                .then(response => {
                    FileSaver(new Blob([response.data], { type: tag.type }), tag.name);
                })
                .catch(error => {
                    console.log(error);
                });
        },
        handleObjectPhotoTagClick(tag) {
            if (!tag.id) {
                return;
            }
            this.$store.dispatch('deals/getPhoto', { block: 'object', id: tag.id })
                .then(response => {
                    FileSaver(new Blob([response.data], { type: tag.type }), tag.name);
                })
                .catch(error => {
                    console.log(error);
                });
        }
    },
    watch: {
        measure_photo: {
            handler(value) {
                if (this.uploadFileList && value.length) {
                    this.uploadFileList = [...value];
                }
            },
            deep: true
        },
        object_photo: {
            handler(value) {
                if (this.uploadObjectPhotoFileList && value.length) {
                    this.uploadObjectPhotoFileList = [...value];
                }
            },
            deep: true
        }
    },
    mounted() {
        if (this.uploadFileList && this.uploadFileList.length === 0 && this.measure_photo.length) {
            this.uploadFileList = [...this.measure_photo];
        }
        if (this.uploadObjectPhotoFileList && this.uploadObjectPhotoFileList.length === 0 && this.object_photo.length) {
            this.uploadObjectPhotoFileList = [...this.object_photo];
        }
    }
};
</script>
